import ready from 'document-ready'
import { OfferKitEmbeddable } from './modules/offerkit'
import { logger } from './util/logger'

ready(async () => {
  try {
    OfferKitEmbeddable.install()
    logger.initialise()
  } catch (e) {
    console.error('[OfferKit] failed to install', e)
  }
})
